import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Divider, Flex, Image, InputNumber } from "antd";
import Title from "antd/es/typography/Title";
import { SimpleModal } from "components/containers";
import { BaseButton } from "components/elements";
import ProductItem from "pages/school/order/product/ProductItem";
import { useEffect, useState } from "react";

export const OrderBookCard = ({item}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [count, setCount] = useState(0)

  const fnProductMinus = () => {
    if (count > 0) {
      setCount(count-1)
    }
  }
  const fnProductPlus = () => {
    if (count < item.INVENTORY_EA ) {
      setCount(count+1)
    }else{
      alert('재고가 부족합니다.')
    }
  }

  useEffect(()=>{
    item.PRODUCT_QTY ? setCount(item.PRODUCT_QTY) : setCount(0)
  },[item])
  
  return (
    <>
      <div>
        <ProductItem
          width={'200px'}
          height={'184px'}
          item={item}
          title={item?.PRODUCT_NAME}
          content={item?.SALE_PRICE}
          onClick={() => setIsOpen(true)}
        />
        <Divider className="divider-small" />

        <Flex justify={'center'} gap={'small'} style={{minWidth: '139px', maxWidth: '200px'}}>
          <BaseButton width={'30%'} icon={<MinusOutlined />} onClick={fnProductMinus} />
          <InputNumber value={count} min={0} controls={false} />
          <BaseButton width={'30%'} icon={<PlusOutlined />} onClick={fnProductPlus} />
        </Flex>
      </div>

      <SimpleModal
        width={'80%'}
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <Divider className="divider-small" />
        <Flex align={'center'} vertical={true} gap={'middle'}>
          <Title level={2}>{item?.PRODUCT_NAME}</Title>
          <Flex vertical>
            {item?.PRODUCT_DETAIL_CONTENT}
          </Flex>
          <Image preview={false} src={item?.PRODUCT_THUMBNAIL_PATH} width={'30%'} />
        </Flex>
      </SimpleModal>
    </>
  )
}
